// Import all your components here
// But don't code inside this file.
// camelCase your file name

// Utilities first so you can use it through all your other files
import './utils/polyfills';

import BarbaRemoval from './global/barbaRemoval';
import Cursor from "./components/cursor";
import gsap from "gsap";
import SplitText from './vendor/gsap/SplitText';
// import './components/gravityForm';

// Enables HMR for JS files imported here
if (module.hot)
  module.hot.accept();

// Signed by Choosit!
// console.log(`%cMade with ❤️ by Choosit!`, `color: #009ee0;`);

const App = {
  init() {
    gsap.registerPlugin(SplitText);
    window.cursor = new Cursor(document.querySelector('.cursor'));
    return new BarbaRemoval();
  }
};
App.init();
